<template>
  <a-spin size="large" :spinning="loading">
    <div>
      <div class="header">
        <div class="title" :class="[lang]">
          <a-icon
            type="control"
            class="icon"
            :style="{ 'margin-left': lang == 'AR' ? '5px' : 0 }"
          />
          {{ $t("PersonalizedTrainingSession") }}
        </div>
        <div class="subtitle" :class="[lang]">
          {{ $t("LetSnowtrainAI") }}
        </div>
      </div>
      <!-- <div>{{ list }}</div> -->
      <div class="list">
        <div class="item-box" v-for="(item, index) in list" :key="index">
          <div class="title" :class="[lang]">
            <span
              class="index"
              :style="{ 'margin-left': lang == 'AR' ? '5px' : 0 }"
              >{{ item.index }}</span
            >{{ item.title }}
          </div>
          <div class="des" :class="[lang]">
            {{ item.subtitle }}
          </div>
          <a-icon
            :style="{
              left: lang == 'AR' ? '20px' : 'inherit',
              right: lang != 'AR' ? '30px' : 'inherit',
            }"
            type="down"
            class="openBtn"
            v-if="!item.open"
            @click="openHandler(item)"
          />
          <a-icon
            type="up"
            class="openBtn"
            v-if="item.open"
            :style="{
              left: lang == 'AR' ? '20px' : 'inherit',
              right: lang != 'AR' ? '30px' : 'inherit',
            }"
            @click="openHandler(item)"
          />
          <div v-show="item.open">
            <div class="cont-box">
              <div class="stitle">
                {{ $t("SampleMessage") }}
                <template v-if="item.can_translate">
                  <a-tooltip
                    v-if="!item.gloading"
                    v-model="item.showModal"
                    placement="bottom"
                  >
                    <template slot="title">
                      <p>
                        {{
                          lang == "CN"
                            ? item.translation_hint.cn
                            : lang == "US"
                            ? item.translation_hint.us
                            : item.translation_hint.ar
                        }}
                      </p>
                    </template>
                    <span
                      ><a-icon
                        type="exclamation-circle"
                        theme="filled"
                        style="color: red; margin-left: 5px"
                      />
                    </span>
                  </a-tooltip>
                  <a-button
                    size="small"
                    @click="generateHandler(item)"
                    style="
                      color: #fff;
                      background: red;
                      border-color: red;
                      margin-left: 5px;
                    "
                  >
                    <a-icon
                      v-if="item.gloading"
                      type="sync"
                      spin
                      class="icon"
                    />
                    {{
                      !item.gloading ? $t("Regenerate") : $t("Regenerating")
                    }}</a-button
                  >
                </template>
              </div>
              <div
                class="cont"
                :style="{ color: item.color ? item.color : '#000' }"
                v-html="
                  formatText(
                    item.new_simulate_content
                      ? item.new_simulate_content
                      : item.cont
                  )
                "
              ></div>
            </div>
            <div class="addTitle" v-if="lang !== 'AR'">
              <span class="tit" :class="[lang]"
                >🎓 {{ $t("TeachAIYourConversation") }}</span
              >
              <span
                v-if="!item.loading && !item.gloading"
                class="btn"
                :class="[lang]"
                @click="addItem(item)"
                >+{{ $t("AddTrainingPhrases") }}</span
              >
              <span
                v-if="item.loading || item.gloading"
                class="btn"
                :class="[lang]"
                style="
                  color: #fff;
                  background-color: #bbbbbb;
                  cursor: not-allowed;
                "
                >+{{ $t("AddTrainingPhrases") }}</span
              >
            </div>
            <div class="addTitle" v-else>
              <span class="btn" :class="[lang]" @click="addItem(item)"
                >+{{ $t("AddTrainingPhrases") }}</span
              >
              <span class="tit" :class="[lang]"
                >🎓 {{ $t("TeachAIYourConversation") }}</span
              >
            </div>
            <ul>
              <li v-for="(jitem, jindex) in item.scriptList" :key="jindex">
                <div class="sciptIndex" v-if="lang != 'AR'">
                  <span class="index" :class="[lang]">{{
                    $t("Script").replace("1", jindex + 1)
                  }}</span>
                  <a-icon
                    v-if="jindex != 0 && !item.loading"
                    type="delete"
                    class="del"
                    @click="delHandler(jindex, item)"
                  />
                </div>
                <div class="sciptIndex" :class="[lang]" v-if="lang == 'AR'">
                  <a-icon
                    v-if="jindex != 0 && !item.loading"
                    type="delete"
                    class="del"
                    @click="delHandler(jindex, item)"
                  />
                  <span class="index" :class="[lang]">{{
                    $t("Script").replace("1", jindex + 1)
                  }}</span>
                </div>
                <div class="scriptInput">
                  <a-input
                    :disabled="item.loading || item.gloading ? true : false"
                    :class="[lang]"
                    type="textarea"
                    v-model="jitem.value"
                    :auto-size="{ minRows: 5, maxRows: 10 }"
                    @click="
                      clickInput(
                        jitem,
                        campaign_type == 1
                          ? $t('salesExpt' + item.index)
                          : $t('hrExpt' + item.index)
                      )
                    "
                    :placeholder="
                      campaign_type == 1
                        ? $t('salesExpt' + item.index)
                        : $t('hrExpt' + item.index)
                    "
                  ></a-input>
                </div>
              </li>
            </ul>
            <div style="visibility: hidden">{{ item.timeteamp }}</div>
            <div class="wrap-btn">
              <a-button
                v-if="!item.loading && !item.gloading"
                class="btn"
                type="primary"
                :class="[lang]"
                @click="useDefaultHandler(item)"
                >{{ $t("UseDefaultScript") }}</a-button
              >
              <a-button
                v-if="item.loading || item.gloading"
                class="btn disabledClass"
                type="primary"
                :class="[lang]"
                @click="useDefaultHandler(item)"
                >{{ $t("UseDefaultScript") }}</a-button
              >
              <a-button
                class="btn"
                :class="[lang]"
                :disabled="item.loading || item.gloading ? true : false"
                @click="saveStepHandler(item)"
                style="background-color: rgba(184, 134, 248, 1); color: #fff"
              >
                <a-icon v-if="item.loading" type="sync" spin class="icon" />

                {{
                  item.loading ? $t("AIischecking") : $t("saveandAIcheck")
                }}</a-button
              >
            </div>
            <div class="tipsloading" v-if="item.loading">
              <a-icon type="sync" spin class="icon" />
              {{ $t("checkingthewording") }}
            </div>
            <div
              class="passed"
              v-if="
                item.status == 2 &&
                item.corpus_examples &&
                item.corpus_examples.length > 0 &&
                !item.loading
              "
            >
              <span>{{ $t("passed") }}</span> {{ $t("Contentapproved") }}
            </div>

            <div class="passed failed" v-if="item.status == 4 && !item.loading">
              <span>{{ $t("Failed") }}</span> {{ $t("Contentrejected") }}
            </div>
            <div
              v-if="item.status == 4 && !item.loading"
              class="cont-box"
              style="
                margin-top: 18px;
                background-color: #ffefbd;
                border-left-color: #ffc109;
              "
            >
              <div
                class="stitle"
                style="color: #000; font-size: 16px; font-weight: bold"
              >
                {{ $t("Suggestededits") }}
              </div>
              <div class="cont">
                {{ item.suggestion }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="wrap-easy">
        <ul>
          <li v-for="(item, index) in list2" :key="index">
            <div class="title">
              <span class="index">{{ item.index }}</span
              >{{ item.title }}
            </div>
            <div class="des">{{ item.subtitle }}</div>
            <div class="fullscreen">
              <a-icon
                class="icon"
                type="fullscreen"
                @click="handleFullScreen(item, index)"
              />
            </div>
          </li>
        </ul>
      </div>

      <div class="tips" v-if="list2.length > 0">
        {{ $t("TohavetheAImaster") }}
      </div>
      <div class="main-btn">
        <a-button class="btn" :class="[lang]" @click="backHandler">{{
          $t("Back")
        }}</a-button>
        <a-button class="btn" :class="[lang]" @click="saveAll" type="primary">{{
          $t("Nextstep")
        }}</a-button>
      </div>
    </div>
  </a-spin>
</template>
<script>
import axios from "axios";

export default {
  data() {
    let that = this;
    return {
      // 正在检查的数目
      processingNum: 0,
      startChecking: false,
      //定时器
      timer: null,
      loading: false,
      //定义通过检查的数据
      passedObj: {
        type1: null,
        type2: null,
        type3: null,
        type4: null,
        type5: null,
        type6: null,
        type7: null,
        type8: null,
      },
      // 正在检查的数据
      checkingObj: {
        type1: null,
        type2: null,
        type3: null,
        type4: null,
        type5: null,
        type6: null,
        type7: null,
        type8: null,
      },
      list: [
        {
          title:
            that.campaign_type == 1
              ? that.$t("InitialOutreach2")
              : that.$t("hrTitle1"),
          subtitle:
            that.campaign_type == 1
              ? that.$t("Sendpersonalizedgreeting")
              : that.$t("hrSubtitle1"),
          cont: "",
          open: true,
          is_default: 1,
          index: 1,
          loading: false,
          scriptList: [
            {
              value: "",
            },
          ],
        },
        {
          title:
            that.campaign_type == 1
              ? that.$t("PainPointIdentification")
              : that.$t("hrTitle2"),
          subtitle:
            that.campaign_type == 1
              ? that.$t("Probedeeper")
              : that.$t("hrSubtitle2"),
          cont: "",
          open: true,
          index: 2,
          is_default: 1,
          loading: false,
          scriptList: [
            {
              value: "",
            },
          ],
        },
        {
          title:
            that.campaign_type == 1
              ? that.$t("ProductAlignment")
              : that.$t("hrTitle3"),
          subtitle:
            that.campaign_type == 1
              ? that.$t("Connectproduct")
              : that.$t("hrSubtitle3"),
          cont: "",
          open: true,
          is_default: 1,
          index: 3,
          loading: false,
          scriptList: [
            {
              value: "",
            },
          ],
        },
      ],
      list2: [
        {
          title:
            that.campaign_type == 1
              ? that.$t("QASupport")
              : that.$t("hrTitle4"),
          subtitle:
            that.campaign_type == 1
              ? that.$t("RespondingtoUser")
              : that.$t("hrSubtitle4"),
          cont: "",
          open: true,
          is_default: 1,
          index: 4,
          scriptList: [
            {
              value: "",
            },
          ],
        },
        {
          title:
            that.campaign_type == 1
              ? that.$t("ContactCapture")
              : that.$t("hrTitle5"),
          subtitle:
            that.campaign_type == 1
              ? that.$t("Guideusers")
              : that.$t("hrSubtitle5"),
          cont: "",
          open: true,
          is_default: 1,
          index: 5,
          scriptList: [
            {
              value: "",
            },
          ],
        },
        {
          title:
            that.campaign_type == 1
              ? that.$t("WhenUsers")
              : that.$t("hrTitle6"),
          subtitle:
            that.campaign_type == 1
              ? that.$t("Responsewhen")
              : that.$t("hrSubtitle6"),
          cont: "",
          open: true,
          is_default: 1,
          index: 6,
          scriptList: [
            {
              value: "",
            },
          ],
        },
        {
          title:
            that.campaign_type == 1
              ? that.$t("NeedsMismatch")
              : that.$t("hrTitle7"),
          subtitle:
            that.campaign_type == 1
              ? that.$t("Responsewhenrequirements")
              : that.$t("hrSubtitle7"),
          cont: "",
          open: true,
          is_default: 1,
          index: 7,
          scriptList: [
            {
              value: "",
            },
          ],
        },
        {
          title: that.$t("hrTitle8"),
          subtitle: that.$t("hrSubtitle8"),
          cont: "",
          open: true,
          is_default: 1,
          index: 8,
          scriptList: [
            {
              value: "",
            },
          ],
        },
      ],
    };
  },
  props: [
    "lgList",
    "complete",
    "campaign_id",
    "campaign_type",
    "scriptList",
    "fromStep",
    "tempDefaultData",
  ],
  mounted() {},
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
      if (this.cancelSource) {
        this.cancelSource.cancel("Operation canceled by the user.");
      }
    }
  },
  created() {
    console.log(this.lgList);

    this.list = this.list.map((item, index) => {
      item.cont = this.lgList[index].translated_content;
      return item;
    });
    if (this.campaign_type == 1) {
      this.list2 = this.list2.slice(0, this.list2.length - 1);
    }
    this.list2 = this.list2.map((item) => {
      item.cont = this.lgList[item.index - 1].translated_content;
      return item;
    });

    this.initData();
    let CancelToken = axios.CancelToken;
    // 创建一个CancelToken
    this.cancelSource = CancelToken.source();
  },
  i18n: require("./i18n"),
  watch: {
    lang() {
      this.changeLange();
    },
  },
  methods: {
    clickInput(item, exp) {
      if (!item.value && !item.clicked) {
        this.$set(item, "value", exp);
        this.$set(item, "clicked", true);
      }
    },
    checkoutStatus() {
      this.timer = setInterval(() => {
        if (this.processingNum <= 0) {
          clearInterval(this.timer);
          return;
        }
        axios
          .post(
            "/sales/get_campaign_scripts",
            {
              campaign_id: parseInt(this.$route.query.campaign_id),
            },
            {
              cancelToken: this.cancelSource.token,
            }
          )
          .then((res) => {
            if (res.code == 200) {
              const { scripts } = res.data;

              scripts.forEach((item) => {
                const {
                  status,
                  suggestion,
                  corpus_type,
                  corpus_examples,
                  simulate_content,
                } = item;
                this.list.forEach((jitem) => {
                  if (
                    jitem.index == corpus_type &&
                    status == 4 &&
                    this.checkingObj["type" + corpus_type] &&
                    corpus_examples.length > 0
                  ) {
                    this.$set(jitem, "status", status);
                    this.$set(jitem, "loading", false);
                    this.$set(jitem, "suggestion", suggestion);
                    this.$set(jitem, "timeteamp", Date.now());
                    // jitem.suggestion = suggestion;
                    this.checkingObj["type" + corpus_type] = null;
                    this.processingNum--;
                    this.$emit("getScriptListHandler");
                  } else if (
                    jitem.index == corpus_type &&
                    status == 2 &&
                    this.checkingObj["type" + corpus_type] &&
                    corpus_examples.length > 0
                  ) {
                    this.$set(jitem, "status", status);
                    this.$set(jitem, "loading", false);
                    this.$set(jitem, "can_translate", false);
                    this.$set(jitem, "corpus_examples", corpus_examples);
                    if (jitem.new_simulate_content != simulate_content) {
                      if (jitem.color) {
                        this.$set(jitem, "color", "#4095e5");
                      } else {
                        this.$set(jitem, "color", "rgba(184, 134, 248, 1)");
                      }
                    }

                    this.$set(jitem, "new_simulate_content", simulate_content);

                    this.$set(jitem, "timeteamp", Date.now());
                    // jitem.status = status;
                    // jitem.loading = false;
                    this.processingNum--;
                    this.passedObj["type" + corpus_type] =
                      this.checkingObj["type" + corpus_type];
                    this.checkingObj["type" + corpus_type] = null;
                    this.$emit("getScriptListHandler");
                  }
                });
                if (this.processingNum <= 0) {
                  clearInterval(this.timer);
                }
              });
            }
          });
      }, 3000);
    },
    generateHandler(item) {
      if (item.gloading) {
        return;
      }
      this.$set(item, "gloading", true);
      this.$axios(
        "/public/translate_corpus_content",
        {
          campaign_id: parseInt(this.campaign_id),
          corpus_id: item.id,
        },
        "post"
      ).then((res) => {
        if (res.code == 200) {
          this.$set(item, "gloading", false);
          this.$set(item, "new_simulate_content", res.data.translated_content);
          this.$set(item, "can_translate", false);
        } else {
          this.$set(item, "gloading", false);
        }
      });
    },
    initData() {
      if (this.scriptList && this.scriptList.length == 0) {
        this.getCampaignInfo();
      } else {
        if (this.fromStep == 2 && this.tempDefaultData) {
          this.list = this.tempDefaultData.list;
          this.list2 = this.tempDefaultData.list2;
          this.list.forEach((item) => {
            if (
              item.status == 2 &&
              item.corpus_examples &&
              item.corpus_examples.length > 0
            ) {
              this.passedObj["type" + item.index] = JSON.stringify(
                item.corpus_examples
              );
            }
          });
          return;
        }
        this.list = [];
        this.list2 = [];
        this.scriptList.forEach((item, index) => {
          let obj = {
            open: true,
            index: item.corpus_type,
            cont: ``,
            status: item.status,
            suggestion: item.suggestion,
            corpus_examples: item.corpus_examples,
            translation_hint: item.translation_hint,
            showModal: true,
            can_translate: item.can_translate,
            id: item.id,
          };
          if (
            item.status == 2 &&
            item.corpus_examples &&
            item.corpus_examples.length > 0
          ) {
            this.passedObj["type" + item.corpus_type] = JSON.stringify(
              item.corpus_examples
            );

            console.log(this.passedObj);
          }

          if (item.corpus_type == 1) {
            obj.title =
              this.campaign_type == 1
                ? this.$t("InitialOutreach2")
                : this.$t("hrTitle1");
            obj.subtitle =
              this.campaign_type == 1
                ? this.$t("Sendpersonalizedgreeting")
                : this.$t("hrSubtitle1");
          }
          if (item.corpus_type == 2) {
            obj.title =
              this.campaign_type == 1
                ? this.$t("PainPointIdentification")
                : this.$t("hrTitle2");
            obj.subtitle =
              this.campaign_type == 1
                ? this.$t("Probedeeper")
                : this.$t("hrSubtitle2");
          }
          if (item.corpus_type == 3) {
            obj.title =
              this.campaign_type == 1
                ? this.$t("ProductAlignment")
                : this.$t("hrTitle3");
            obj.subtitle =
              this.campaign_type == 1
                ? this.$t("Connectproduct")
                : this.$t("hrSubtitle3");
          }
          if (item.corpus_type == 4) {
            obj.title =
              this.campaign_type == 1
                ? this.$t("QASupport")
                : this.$t("hrTitle4");
            obj.subtitle =
              this.campaign_type == 1
                ? this.$t("RespondingtoUser")
                : this.$t("hrSubtitle4");
          }
          if (item.corpus_type == 5) {
            obj.title =
              this.campaign_type == 1
                ? this.$t("ContactCapture")
                : this.$t("hrTitle5");
            obj.subtitle =
              this.campaign_type == 1
                ? this.$t("Guideusers")
                : this.$t("hrSubtitle5");
          }
          if (item.corpus_type == 6) {
            obj.title =
              this.campaign_type == 1
                ? this.$t("WhenUsers")
                : this.$t("hrTitle6");
            obj.subtitle =
              this.campaign_type == 1
                ? this.$t("Responsewhen")
                : this.$t("hrSubtitle6");
          }
          if (item.corpus_type == 7) {
            obj.title =
              this.campaign_type == 1
                ? this.$t("NeedsMismatch")
                : this.$t("hrTitle7");
            obj.subtitle =
              this.campaign_type == 1
                ? this.$t("Responsewhenrequirements")
                : this.$t("hrSubtitle7");
          }
          if (item.corpus_type == 8) {
            obj.title =
              this.campaign_type == 1
                ? this.$t("NeedsMismatch")
                : this.$t("hrTitle8");
            obj.subtitle =
              this.campaign_type == 1
                ? this.$t("Responsewhenrequirements")
                : this.$t("hrSubtitle8");
          }
          obj.cont = item && item.simulate_content;
          if (!item.is_default && item.corpus_examples) {
            let arr = [];
            item.corpus_examples.forEach((script) => {
              arr.push({ value: script });
            });
            obj.scriptList = arr;
            obj.is_default = 0;
          } else {
            obj.is_default = 1;
            obj.scriptList = [
              {
                value: "",
              },
            ];
          }
          if (index < 3 || (!item.is_default && item.corpus_examples)) {
            this.list.push(obj);
            setTimeout(() => {
              this.list = this.list.map((item) => {
                item.showModal = false;
                return item;
              });
            }, 6000);
          } else {
            this.list2.push(obj);
          }
        });
      }
    },
    changeLange() {
      //this.initData();
      this.$nextTick(() => {
        let is_default =
          this.scriptList && this.scriptList.length > 0 ? false : true;
        this.list.forEach((item) => {
          if (item.index == 1) {
            item.title =
              this.campaign_type == 1
                ? this.$t("InitialOutreach2")
                : this.$t("hrTitle1");
            item.subtitle = this.$t("Sendpersonalizedgreeting");
          }
          if (item.index == 2) {
            item.title =
              this.campaign_type == 1
                ? this.$t("PainPointIdentification")
                : this.$t("hrTitle2");
            item.subtitle =
              this.campaign_type == 1
                ? this.$t("Probedeeper")
                : this.$t("hrSubtitle2");
          }
          if (item.index == 3) {
            item.title =
              this.campaign_type == 1
                ? this.$t("ProductAlignment")
                : this.$t("hrTitle3");
            item.subtitle =
              this.campaign_type == 1
                ? this.$t("Connectproduct")
                : this.$t("hrSubtitle3");
          }
          if (item.index == 4) {
            item.title =
              this.campaign_type == 1
                ? this.$t("QASupport")
                : this.$t("hrTitle4");
            item.subtitle =
              this.campaign_type == 1
                ? this.$t("RespondingtoUser")
                : this.$t("hrSubtitle4");
          }
          if (item.index == 5) {
            item.title =
              this.campaign_type == 1
                ? this.$t("ContactCapture")
                : this.$t("hrTitle5");
            item.subtitle =
              this.campaign_type == 1
                ? this.$t("Guideusers")
                : this.$t("hrSubtitle5");
          }
          if (item.index == 6) {
            item.title =
              this.campaign_type == 1
                ? this.$t("WhenUsers")
                : this.$t("hrTitle6");
            item.subtitle =
              this.campaign_type == 1
                ? this.$t("Responsewhen")
                : this.$t("hrSubtitle6");
          }
          if (item.index == 7) {
            item.title =
              this.campaign_type == 1
                ? this.$t("NeedsMismatch")
                : this.$t("hrTitle7");
            item.subtitle =
              this.campaign_type == 1
                ? this.$t("Responsewhenrequirements")
                : this.$t("hrSubtitle7");
          }

          if (item.index == 8) {
            item.title =
              this.campaign_type == 1
                ? this.$t("NeedsMismatch")
                : this.$t("hrTitle8");
            item.subtitle =
              this.campaign_type == 1
                ? this.$t("Responsewhenrequirements")
                : this.$t("hrSubtitle8");
          }
          if (is_default) {
            item.cont =
              this.campaign_type == 1
                ? this.$t("salesExp" + item.index)
                : this.$t("hrExp" + item.index);
          }
        });
        this.list2.forEach((item) => {
          if (item.index == 4) {
            item.title =
              this.campaign_type == 1
                ? this.$t("QASupport")
                : this.$t("hrTitle4");
            item.subtitle =
              this.campaign_type == 1
                ? this.$t("RespondingtoUser")
                : this.$t("hrSubtitle4");
          }
          if (item.index == 5) {
            item.title =
              this.campaign_type == 1
                ? this.$t("ContactCapture")
                : this.$t("hrTitle5");
            item.subtitle =
              this.campaign_type == 1
                ? this.$t("Guideusers")
                : this.$t("hrSubtitle5");
          }
          if (item.index == 6) {
            item.title =
              this.campaign_type == 1
                ? this.$t("WhenUsers")
                : this.$t("hrTitle6");
            item.subtitle =
              this.campaign_type == 1
                ? this.$t("Responsewhen")
                : this.$t("hrSubtitle6");
          }
          if (item.index == 7) {
            item.title =
              this.campaign_type == 1
                ? this.$t("NeedsMismatch")
                : this.$t("hrTitle7");
            item.subtitle =
              this.campaign_type == 1
                ? this.$t("Responsewhenrequirements")
                : this.$t("hrSubtitle7");
          }

          if (item.index == 8) {
            item.title =
              this.campaign_type == 1
                ? this.$t("NeedsMismatch")
                : this.$t("hrTitle8");
            item.subtitle =
              this.campaign_type == 1
                ? this.$t("Responsewhenrequirements")
                : this.$t("hrSubtitle8");
          }
          if (is_default) {
            item.cont =
              this.campaign_type == 1
                ? this.$t("salesExp" + item.index)
                : this.$t("hrExp" + item.index);
          }
        });
      });
    },
    saveAllData(id) {
      let arr = [];
      let loadingTotal = 0;
      let stopTip = "";
      this.list.forEach((item) => {
        let scripts = [];

        if (item.loading) {
          let str = this.$t("checkStepContent");
          if (!stopTip) {
            stopTip = str.replace("xxx", item.title);
          }
          loadingTotal++;
        }
        item.scriptList &&
          item.scriptList.map((jitem) => {
            if (jitem.value) {
              scripts.push(jitem.value);
            }
          });

        let obj = {
          title: item.title,
          corpus_type: item.index,
          is_default: scripts.length > 0 ? 0 : 1,
          corpus_examples: scripts,
          status: item.status,
        };
        arr.push(obj);
      });
      if (loadingTotal > 0 && stopTip) {
        this.$error({
          title: "",
          content: stopTip,
        });
        return;
      }
      this.list2.forEach((item) => {
        let scripts = [];
        item.scriptList &&
          item.scriptList.map((jitem) => {
            if (jitem.value) {
              scripts.push(jitem.value);
            }
          });

        let obj = {
          title: item.title,
          corpus_type: item.index,
          is_default: scripts.length > 0 ? 0 : 1,
          corpus_examples: scripts,
          status: item.status,
        };
        arr.push(obj);
      });
      let defaultList = [];
      let tips = "";
      arr.map((item) => {
        if (item.is_default) {
          defaultList.push(item.corpus_type);
        } else {
          if (item.status != 2) {
            let str = this.$t("checkStepContent");
            if (!tips) {
              tips = str.replace("xxx", item.title);
            }
          }

          // else if (
          //   item.status == 2 &&
          //   JSON.stringify(item.corpus_examples) !=
          //     this.passedObj["type" + item.corpus_type]
          // ) {
          //   let str = this.$t("checkStepContent");
          //   if (!tips) {
          //     tips = str.replace("xxx", item.title);
          //   }
          // }
        }
      });
      if (tips) {
        this.$error({
          title: "",
          content: tips,
        });
        return;
      }

      if (defaultList.length == 0) {
        this.$emit("setFromStep", 2);
        this.$emit("showStep3", 3);
        return;
      }
      this.loading = true;
      this.$axios(
        "/sales/set_default_script",
        {
          campaign_id: parseInt(id),
          corpus_types: defaultList.join(","),
        },
        "post"
      )
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            if (
              (this.campaign_type == 1 && defaultList.length == 7) ||
              (this.campaign_type == 2 && defaultList.length == 8)
            ) {
              this.$emit("setFromStep", 1);
            } else {
              this.$emit("setTempDefaultData", {
                list: this.list,
                list2: this.list2,
              });
              this.$emit("setFromStep", 2);
            }
            this.$emit("showStep3", 3);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleFullScreen(item, index) {
      this.list2.splice(index, 1);
      this.list.push(item);
      let arr = this.list;
      arr.sort((a, b) => a.index - b.index);
      this.list = arr;
    },
    getCampaignInfo() {
      this.$axios(
        "/sales/get_latest_script_training",
        {
          campaign_type: this.campaign_type,
        },
        "post"
      ).then((res) => {
        if (res.code == 200) {
          let data = res.data.scripts || [];
          data.forEach((item) => {
            this.list.forEach((jitem) => {
              if (item.corpus_type == jitem.index && item.corpus_examples) {
                let arr = [];
                item.corpus_examples.map((val) => {
                  arr.push({ value: val });
                });

                jitem.scriptList = arr;
              }
            });
          });

          data.forEach((item) => {
            this.list2.forEach((jitem) => {
              if (item.corpus_type == jitem.index && item.corpus_examples) {
                let arr = [];
                item.corpus_examples.map((val) => {
                  arr.push({ value: val });
                });

                jitem.scriptList = arr;
              }
            });
          });
        }
      });
    },
    saveStepHandler(item) {
      let arr = [];
      let contArr = [];

      if (item.scriptList) {
        item.scriptList.forEach((aa) => {
          if (aa.value && aa.value.trim()) {
            aa.value = aa.value.trim();
            arr.push(aa);
            contArr.push(aa.value);
          }
        });
      }
      if (arr.length == 0) {
        item.is_default = 1;
        item.scriptList = [
          {
            value: "",
          },
        ];
        item.open = false;
        this.$set(item, "loading", false);
        this.$set(item, "suggestion", "");
        this.$set(item, "status", 0);
        this.passedObj["type" + item.index] = null;
      } else {
        // item.scriptList = arr;
        item.is_default = 0;
        let { campaign_id } = this.$route.query;
        // debugger;
        this.$set(item, "loading", true);
        // item.loading = true;
        this.processingNum++;
        console.log("this.processingNum", this.processingNum);
        this.$axios(
          "/sales/insert_single_script_training",
          {
            campaign_id: parseInt(campaign_id),
            is_default: 0,
            corpus_examples: contArr,
            corpus_type: item.index,
          },
          "post"
        )
          .then((res) => {
            if (res.code == 200 && res.data.status == "success") {
              this.checkingObj["type" + item.index] = JSON.stringify(contArr);
              if (!this.startChecking) {
                this.checkoutStatus();
              }
            } else if (
              (res.code == 200 && res.data.status == "rejected") ||
              res.code != 200
            ) {
              this.$set(item, "loading", false);
              this.$set(item, "status", 4);
              this.$set(item, "suggestion", res.data.message || res.msg);
              this.checkingObj["type" + item.index] = null;
              this.processingNum--;
            }
          })
          .catch(() => {
            this.$set(item, "loading", false);
            this.$set(item, "status", 0);
          });
      }
    },
    saveAll() {
      // this.loading = true;
      let { campaign_id } = this.$route.query;
      this.saveAllData(campaign_id, 0);
    },
    useDefaultHandler(item) {
      if (item.loading) {
        return;
      }
      item.open = false;
      item.is_default = 1;
      this.$set(item, "status", 0);
      this.$set(item, "loading", false);
      this.$set(item, "suggestion", "");
      this.$set(item, "color", "");
      this.$set(item, "new_simulate_content", "");
      this.passedObj["type" + item.index] = null;
      this.$set(item, "scriptList", [
        {
          value: "",
        },
      ]);

      let { campaign_id } = this.$route.query;
      this.$axios(
        "/sales/insert_single_script_training",
        {
          campaign_id: parseInt(campaign_id),
          is_default: 1,
          corpus_examples: [],
          corpus_type: item.index,
        },
        "post"
      ).then((res) => {
        if (res.code == 200) {
          this.$emit("getScriptListHandler");
        }
      });
    },
    openHandler(item) {
      this.$set(item, "open", !item.open);
    },
    delHandler(jindex, item) {
      item.scriptList.splice(jindex, 1);
    },
    backHandler() {
      this.$emit("backHandler", 1);
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
        if (this.cancelSource) {
          this.cancelSource.cancel("Operation canceled by the user.");
        }
      }
    },
    formatText(text) {
      const msg = text.replace(/\n/g, "<br>").replace(/\r/g, "<br>");
      return msg;
    },

    addItem(item) {
      item.scriptList.push({
        value: "",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  text-align: center;
  margin-bottom: 20px;
  .title {
    font-size: 24px;
    margin: 0 0 10px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    .icon {
      font-size: 24px;
      color: #0e756a;
    }
  }

  .subtitle {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.52);
  }
}
.tipsloading {
  .icon {
    margin-right: 5px;
  }
  color: #09796c;
  font-size: 16px;
  margin-top: 18px;
}
.disabledClass {
  color: #fff;
  background: #bbbbbb;
  cursor: not-allowed;
  border-color: #bbbbbb;
}
.passed {
  display: flex;
  align-items: center;
  margin-top: 18px;
  span {
    display: inline-block;
    height: 22px;
    font-size: 14px;
    line-height: 22px;
    padding: 0 12px;
    color: #fff;
    background: #2fbf3d;
    margin-right: 8px;
    border-radius: 11px;
  }
  color: #09796c;
  font-size: 16px;
}
.failed {
  span {
    background: #df2e22;
  }
  color: #df2e22;
}

.list {
  .item-box {
    border-radius: 6px;
    background-color: rgba(239, 239, 239, 1);
    padding: 16px;
    margin-bottom: 12px;
    position: relative;
    .openBtn {
      position: absolute;
      right: 30px;
      top: 40px;
      cursor: pointer;
    }
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-weight: bold;
      .index {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        border-radius: 50%;
        background-color: rgba(16, 117, 106, 1);
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        text-align: center;
        font-family: PingFangSC-bold;
        margin-right: 5px;
      }
      color: rgba(0, 0, 0, 1);
      font-size: 16px;
      text-align: left;
      font-family: PingFangSC-bold;
    }
    .des {
      color: rgba(0, 0, 0, 0.4);
      font-size: 12px;
      font-family: PingFangSC-regular;
      margin-bottom: 12px;
    }
    .cont-box {
      background: #fff;
      border-left: rgba(16, 117, 106, 1) solid 8px;
      border-radius: 6px;
      padding: 16px;
      font-size: 14px;
      .stitle {
        color: rgba(16, 117, 106, 1);
        text-align: left;
        font-family: PingFangSC-bold;
        margin-bottom: 8px;
      }
      .cont {
        line-height: 22px;
      }
    }
    .addTitle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 54px;
      .tit {
        font-size: 14px;
        font-weight: bold;
      }
      .btn {
        background-color: rgba(64, 149, 229, 1);
        height: 24px;
        line-height: 24px;
        padding: 0 6px;
        cursor: pointer;
        border-radius: 4px;
        color: #fff;
      }
    }
    .sciptIndex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      .index {
        color: #0e756a;
      }
      .del {
        cursor: pointer;
      }
    }
    .scriptInput {
      margin-bottom: 12px;
    }
    .text {
      margin-bottom: 12px;
    }
    .wrap-btn {
      text-align: center;
      .btn {
        margin: 0 10px;
      }
    }
  }
}
.wrap-easy {
  margin-top: 15px;
  ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    li {
      width: calc(25% - 8px);
      box-sizing: border-box;
      border-radius: 10px;
      // box-sizing: content-box;
      padding: 12px;
      background-color: rgba(239, 239, 239, 1);
      padding-top: 20px;
      .title {
        display: flex;
        align-items: flex-start;
        margin-bottom: 12px;
        font-weight: bold;
        .index {
          display: inline-block;
          width: 24px;
          height: 24px;
          line-height: 24px;
          border-radius: 50%;
          background-color: rgba(16, 117, 106, 1);
          color: rgba(255, 255, 255, 1);
          font-size: 16px;
          text-align: center;
          font-family: PingFangSC-bold;
          margin-right: 5px;
        }
        color: rgba(0, 0, 0, 1);
        font-size: 16px;
        text-align: left;
        font-family: PingFangSC-bold;
      }
      .des {
        margin-top: 30px;
        text-align: left;
        font-family: PingFangSC-regular;
        font-size: 12px;
        font-style: italic;
        height: 40px;
        line-height: 20px;
        overflow: hidden;
      }
      .fullscreen {
        margin-top: 30px;
        text-align: right;
        font-size: 22px;
        cursor: pointer;
      }
    }
    :first-child {
      margin-left: 0;
    }
  }
}
.tips {
  margin-top: 16px;
  padding: 11px 7px;
  height: 45px;
  background-color: rgba(255, 239, 189, 1);
  border-left: rgba(244, 206, 152, 0.85) solid 8px;
  border-radius: 8px;
  color: rgba(155, 125, 49, 0.85);
}
.main-btn {
  margin-top: 22px;
  text-align: center;
  margin-bottom: 30px;
  .btn {
    margin: 0 10px;
  }
}
</style>
